import NiotaClassicApiService from '../../../../services/niotaClassicApiService';
import get from 'lodash/get';
import cloneDeep from 'lodash/cloneDeep';

export default {
  props: {},
  data: function () {
    return {
      euiDeviceMapping: {},
    };
  },
  computed: {
    euiRules() {
      return [
        (v) =>
          (!!v && typeof v === 'string' && /^([0-9A-F]{16})$/gi.exec(v.trim()) !== null) ||
          this.$i18n_tc('DigitalTwin.DigitalTwin.copy.euiRule', 16 * 4, { n: 16 * 4 }),
      ];
    },
  },
  methods: {
    fetchIotHubDeviceEui(iotHubState) {
      const deviceIdentifier = iotHubState.properties.binding.options.identifier;
      const foundMapping = Object.values(this.euiDeviceMapping).find((mapping) => {
        return mapping.id === deviceIdentifier;
      });
      if (foundMapping) {
        return Promise.resolve(foundMapping.eui);
      }
      return NiotaClassicApiService.deviceGetDetails(iotHubState.properties.binding.options.identifier)
        .then((res) => {
          let device = get(res, 'data.device');
          if (!device || !device.id) {
            throw new Error('NIOTA_DEVICE_NOT_FOUND');
          } else {
            this.euiDeviceMapping[device.eui] = {
              id: device.id,
              title: device.title,
              eui: device.eui,
            };
          }
          return device.eui;
        })
        .catch(() => {
          return null;
        });
    },
    fetchIotHubDetails(state, twin, cloneOriginalStates = true) {
      if (
        !state.properties.binding.options.eui ||
        /^([0-9A-F]{16})$/gi.exec(state.properties.binding.options.eui.trim()) === null
      ) {
        return;
      }
      state.properties.binding.options.identifier = null;
      state.deviceTitle = null;

      return this.fetchIotHubDeviceDetails(state.properties.binding.options.eui).then((details) => {
        state.properties.binding.options.eui = details.eui;
        state.properties.binding.options.identifier = details.id;
        state.deviceTitle = details.title;
        if (twin && cloneOriginalStates) {
          twin.states = cloneDeep(twin.states);
        }
        if (cloneOriginalStates) {
          this.$emit('cloneOrgTwinStates');
        }
      });
    },
    fetchIotHubDeviceDetails(eui) {
      const trimmedEui = (!eui || typeof eui !== 'string' ? '' : eui).trim();
      if (!eui || typeof eui !== 'string' || /^([0-9A-F]{16})$/gi.exec(trimmedEui) === null) {
        return Promise.resolve({
          id: null,
          eui: `${this.$i18n_t('NiotaClassic.Devices.snacks.notFound')}`,
        });
      }
      if (this.euiDeviceMapping[trimmedEui]) {
        return Promise.resolve(this.euiDeviceMapping[trimmedEui]);
      }
      return NiotaClassicApiService.devicesFind(trimmedEui, 0, 1, 'title', 'ASC')
        .then((res) => {
          let device = get(res, 'data.device') || get(res, 'data.devices[0]');
          if (!device || !device.id) {
            throw new Error('NIOTA_DEVICE_NOT_FOUND');
          } else {
            this.euiDeviceMapping[trimmedEui] = {
              id: device.id,
              title: device.title,
              eui: device.eui,
            };
          }
          return this.euiDeviceMapping[trimmedEui];
        })
        .catch((error) => {
          this.euiDeviceMapping[trimmedEui] = {
            id: null,
            eui: `${trimmedEui} ${this.$i18n_t('NiotaClassic.Devices.snacks.notFound')}`,
          };
          console.error(error);
          let errorMessage = get(error, 'response.data.message', error.message);
          let errorOutput = this.$i18n_te(`Error.${errorMessage}`)
            ? this.$i18n_t(`Error.${errorMessage}`)
            : this.$i18n_t(errorMessage);
          this.$snack(errorOutput, 'error');
          return this.euiDeviceMapping[trimmedEui];
        });
    },
  },
};
